var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._g(_vm._b({staticClass:"sh-input",attrs:{"clearable":_vm.clearable}},'el-input',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }